import "./Footer.css";
import { axiosApi } from "../Api/Axios";
import { useEffect, useState } from "react";

const Footer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [versionInfo, setVersionInfo] = useState('');
  const [error, setError] = useState(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    handleVersionInfo();
  }, []);

  const handleVersionInfo = async () => {
    
    try {
      setIsLoading(true);
      const response = await axiosApi.get("/api/auth/version-info", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setVersionInfo(response.data);
      } else {
        setError("Error fetching version info");
      }
    } catch (err) {
      console.error("Error fetching version info:", err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }

  const getEnvironmentDisplay = () => {
    const reactEnv = process.env.REACT_APP_ENV;
    const serverEnv = versionInfo?.environment;

    // Use React environment if available, fallback to server environment
    const env = reactEnv || serverEnv;

    switch (env?.toLowerCase()) {
      case "development":
        return "Dev";
      case "staging":
        return "Staging";
      case "production":
        return "Release";
      case "dwcstaging":
        return "DWC Staging";
      default:
        return env || "Unknown";
    }
  };

  const getVersionDisplay = () => {
    if (isLoading) {
      return "Loading...";
    }

    if (error || !versionInfo) {
      return "";
    }

    return `${getEnvironmentDisplay()} ${versionInfo.version}`;
  };

  const getTooltipText = () => {
    if (isLoading) {
      return "Loading version information...";
    }

    if (error || !versionInfo) {
      return "Version information unavailable";
    }

    return `${versionInfo.informationalVersion} - Built: ${versionInfo.buildDate}`;
  };

  return (
    <footer>
      <div className="footer-gp">
        <div className="footer-container">
          <div>
            {versionInfo?.copyright ||
              `Copyright © ${new Date().getFullYear()}. MAST - Marine & Safety Tasmania`}
          </div>

          <span className="float-end">
            <div>
              <span title={getTooltipText()}>
                <small>
                  <em>{getVersionDisplay()}</em>
                </small>
              </span>
            </div>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
